import { useWithdrawDialog } from './logic/useWithdrawDialog'
import { WithdrawView } from './views/WithdrawView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { DialogContentContainerProps } from '@/features/dialogs/common/types'
import { SuccessView } from '@/features/dialogs/common/views/SuccessView'
import { withSuspense } from '@/ui/utils/withSuspense'

function WithdrawDialogContentContainer({ token, closeDialog }: DialogContentContainerProps) {
  const {
    actionsViewState,
    withdrawOptions,
    assetsToWithdrawFields,
    pageStatus,
    form,
    withdrawAsset,
    currentPositionOverview,
    updatedPositionOverview,
    riskAcknowledgement,
  } = useWithdrawDialog({ initialToken: token })

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        objectiveType="withdraw"
        tokenWithValue={withdrawAsset}
        onProceed={closeDialog}
        proceedText="View in portfolio"
      />
    )
  }

  return (
    <WithdrawView
      withdrawOptions={withdrawOptions}
      actionsViewState={actionsViewState}
      form={form}
      assetsToWithdrawFields={assetsToWithdrawFields}
      withdrawAsset={withdrawAsset}
      currentPositionOverview={currentPositionOverview}
      updatedPositionOverview={updatedPositionOverview}
      riskAcknowledgement={riskAcknowledgement}
    />
  )
}

const WithdrawDialogContentContainerWithSuspense = withSuspense(WithdrawDialogContentContainer, DialogContentSkeleton)
export { WithdrawDialogContentContainerWithSuspense as WithdrawDialogContentContainer }
